export const challengeTypeNames = ['easy', 'medium', 'hard'];
